<template>
    <div class="min-h-screen flex items-center justify-center flex-col bg-gray-100">
        <div class="mb-5">
            <img src="/images/logo.png" alt="Produce Express Wholesale" class="w-full sm:max-w-md px-6">
        </div>

        <div class="bg-white p-5 rounded w-full" style="max-width: 460px">
            <h1 class="text-2xl mb-5 text-gray-700">Set Password</h1>

            <form @submit.prevent="handleSubmit">
                <div class="mb-5">
                    <jet-label for="password">Password</jet-label>
                    <jet-input id="password" type="password" v-model="form.password" class="w-full block" />
                    <jet-input-error :message="form.errors.password" />
                </div>

                <div class="mb-5">
                    <jet-label for="password_confirmation">Password Confirm</jet-label>
                    <jet-input id="password_confirmation" type="password" v-model="form.password_confirmation" class="w-full block" />
                    <jet-input-error :message="form.errors.password_confirmation" />
                </div>

                <jet-button type="submit">Save</jet-button>
            </form>
        </div>
    </div>
</template>

<script>
import JetButton from '@/Jetstream/Button'
import JetInput from '@/Jetstream/Input'
import JetInputError from '@/Jetstream/InputError'
import JetLabel from '@/Jetstream/Label'

export default {
    components: {
        JetButton,
        JetInput,
        JetInputError,
        JetLabel,
    },

    props: ['token'],

    data () {
        return {
            form: this.$inertia.form({
                password: '',
                password_confirmation: '',
            }),
        }
    },

    methods: {
        handleSubmit () {
            if (!this.form.processing) {
                this.form.post(this.route('customers.set.password', this.token));
            }
        },
    }
}
</script>

<style>

</style>